import store from "../../../../store";
import {
    format
} from '../../../../assets/helpers'

export class CotViService {

    // Obtiene información del producto que se está manejando
    static async getInfoProducto(pId_Empresa, pId_Agente) {
        const payload = {
            metodo: "GET_INFO_PRODUCTO_CV",
            data: {
                pId_Empresa,
                pId_Agente,
            },
        };

        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST[0];
    }

    // Obtiene los planes disponibles
    static async getLineas(pId_Empresa, pId_Producto, pId_Version, pId_Agente) {
        const payload = {
            metodo: "GET_LINEAS_CV",
            data: {
                pId_Empresa,
                pId_Producto,
                pId_Version,
                pId_Agente,
            },
        };
        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST;
    }

    // Obtiene las monedas que maneja el producto ** Por ahora solo MXN
    static async getMonedas(pId_Producto, pId_Version) {
        const payload = {
            metodo: "GET_MONEDAS_CV",
            data: {
                pId_Producto,
                pId_Version,
            },
        };
        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST[0];
    }


    // Retorna el númnero y el id de cotización
    static async getIdCotizacion(pId_Usuario, pId_UsuarioLogueado) {
        const payload = {
            metodo: "GET_NUM_COT_CV",
            data: {
                pId_UsuarioLogueado,
                pId_Usuario,
            },
        };

        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST;
    }

    // Retorna el id del paquete
    static async getPaquete(pId_Producto, pId_Version, pId_Lin_Negocio) {
        const payload = {
            metodo: "GET_PAQUETE_CV",
            data: {
                pId_Producto,
                pId_Version,
                pId_Lin_Negocio,
            },
        };
        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST[0].ID_PAQUETE;
    }


    // Graba cotización
    static async grabaCotizacion(_this) {
        const payload = {
            metodo: "GRABA_COT_CV",
            data: {
                pId_Empresa: _this.pId_Empresa,
                pId_Cotizacion: _this.pId_Cotizacion,
                pId_Version_Pol: "1",
                pF_Fin_Vigencia: format.date(new Date()),
                pId_Producto: _this.ID_PRODUCTO,
                pId_Version: _this.ID_VERSION,
                pId_Moneda: _this.monedas.ID_MONEDA,
                pId_Agente: _this.pId_Agente,
                pId_Usuario: "WEB",
                pId_Lin_Negocio: String(_this.pId_Lin_Negocio),
                pSA_Amparada: format.number(_this.sumaAseg),
                pPct_Dcto: "0",
                pNom_Solicitante: `${_this.nombre} ${_this.app} ${_this.apm}`,
                pNombre_Persona: _this.nombre,
                pApellido_Paterno: _this.app,
                pApellido_Materno: _this.apm,
                pF_Nacimiento: format.date(_this.fecha_nacimiento),
                pCve_Sexo: _this.CVE_SEXO,
                pEstatura: "0",
                pId_Giro_Ocup: "1",
                pPct_IVA: "16",
                pB_Ingr_Cuestionario: "F",
                pB_Cuest_Afirmativo: "F",
                pCve_Edo_Civil: "S",
                pDesc_Lugar_Nac: "Ciudad de México",
                pId_UsuarioLogueado: _this.idUsuario,
                pId_Paquete: _this.ID_PAQUETE,
                pB_Fumador: _this.beneficios.fumador || "F",
                pB_Benef_Mujer: _this.beneficios.mujer || "F",
                pCve_T_Bien: _this.idBien,
            },
        };

        await store.dispatch("metodoPost", payload);
        const response = store.getters.getRespuestaREST;

        if (response.pId_Cod_Resp > 0) {
            _this.$swal("Error", response.pDesc_Codigo)
            return false;
        }
        
        return response;
    }

    // Obtiene coberturas
    static async getCoberturas(_this) {
        const payload = {
            metodo: "GET_COBERTURAS_CV",
            data: {
                pId_Cotizacion: _this.pId_Cotizacion,
                pId_Lin_Negocio: String(_this.pId_Lin_Negocio),
                pId_Usuario: "WEB",
                pId_Moneda: _this.monedas.ID_MONEDA,
                pId_Inciso: "1",
                pId_Version: "1",
                pId_Producto: _this.ID_PRODUCTO,
                pId_Paquete: _this.ID_PAQUETE,
                pId_UsuarioLogueado: _this.pId_Agente,
            },
        };
        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST;
    }

    // Actualiza coberturas
    static async updateCobs(_this, idCobertura, clave, addOrRemove, monto = 0) {
        const payload = {
            metodo: "UPDATE_COBS_CV",
            data: {
                pId_Cotizacion: _this.pId_Cotizacion,
                pId_Producto: _this.ID_PRODUCTO,
                pId_Version: _this.ID_VERSION,
                pId_Lin_Negocio: _this.pId_Lin_Negocio,
                pId_Cobertura: idCobertura,
                pCveL_T_Cobertura: clave,
                pB_Amparada: addOrRemove,
                pCve_T_ExtP_Med: "N",
                pFact_Extp_Med: "0",
                pCve_T_Extp_Ocup: "N",
                pFact_Extp_Ocup: "0",
                pPlazo_ExtP_Med: null,
                pF_Vencto_ExtP_M: null,
                pNum_Renta: "0",
                pImp_Renta: "0",
                pPct_Indexacion: "0",
                pImp_FORE: "0",
                pImp_DOTE: "0",
                pDeducible_Dft: "0",
                pSA_Amparada: format.number(monto),
                pId_Inciso: "1",
                pPct_Subnormalid: "0",
                pF_Nacimiento: format.date(_this.fecha_nacimiento),
                pB_Fumador: _this.beneficios.fumador,
                pB_Benef_Mujer: _this.beneficios.mujer,
                pId_UsuarioLogueado: _this.pId_Agente,
            },
        };
        await store.dispatch("metodoPost", payload);
        const response = store.getters.getRespuestaREST;

        if (response.pId_Cod_Resp > 8) {
            _this.$swal("Error", response.pDesc_Codigo);
            _this.formasPago = [];
            _this.showPrintButton = false;
            return false;
        }
        return response;
    }

    // Cotiza las coberturas
    static async cotizaCobs(_this) {
        const payload = {
            metodo: "COTIZA_COBS_CV",
            data: {
                pId_Empresa: _this.pId_Empresa,
                pId_Cotizacion: _this.pId_Cotizacion,
                pId_Usuario: _this.idUsuario,
                pId_Paquete: _this.ID_PAQUETE,
                pId_Producto: _this.ID_PRODUCTO,
                pId_Version: _this.ID_VERSION,
                pId_Moneda: _this.monedas.ID_MONEDA,
                pId_Forma_Pago: _this.idFormaPago,
                pId_UsuarioLogueado: _this.pId_Agente,
            },
        };

        const flag = await store.dispatch("metodoPost", payload);
        const response = store.getters.getRespuestaREST;

        if (response.pId_Cod_Resp > 0) {
            _this.$swal("Error", response.pDesc_Codigo);
            return flag;
        }
        return response;
    }

    // Obtiene los importes guarddados previamente
    static async getImportes(pId_Cotizacion, pId_Agente) {
        const payload = {
            metodo: "GET_IMPORTES_COT_CV",
            data: {
                pId_Cotizacion,
                pTipo_Doc: "C",
                pId_UsuarioLogueado: pId_Agente,
            },
        };
        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST;
    }





    // ****  Consulta ======================================

    // Obtiene los datos de la cotización
    static async getCotizacionData(pId_Cotizacion, pId_Lin_Negocio, pId_UsuarioLogueado) {
        if (!pId_Lin_Negocio) {
            return [];
        }
        const payload = {
            metodo: "GET_DATOS_ASEG_CV",
            data: {
                pId_Cotizacion,
                pId_Lin_Negocio,
                pId_Inciso: "1",
                pId_UsuarioLogueado,
            },
        };
        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST[0];
    }

    // Obtiene coberturas de cotización previa
    static async getCoberturasData(pId_Cotizacion, pId_Lin_Negocio) {
        if (!pId_Lin_Negocio) {
            return [];
        }
        const payload = {
            metodo: "GET_COBS_GUARDADAS_CV",
            data: {
                pId_Cotizacion,
                pId_Lin_Negocio,
                pId_Inciso: "1",
            },
        };
        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST;
    }

    // Obtiene las formas de pago ** No se ha utilizado
    // static async getFormaPago(pId_Producto, pId_Version) {
    //     const payload = {
    //         metodo: "GEFORMAPAGOQA",
    //         data: {
    //             pId_Producto,
    //             pId_Version,
    //             pId_Moneda: "484",
    //             pId_Cond_Cobro: "15",
    //         },
    //     };
    //     await store.dispatch("metodoPost", payload);
    //     return store.getters.getRespuestaREST;
    // }




    // Otros ============

    // Obtiene el pdf
    static async printPDF(_this) {
        const payload = {
            metodo: "GET_PDF_COTIZACION_QA",
            data: {
                pNum_Poliza: _this.pNum_Cotizacion,
                pId_Producto: _this.ID_PRODUCTO,
                pId_Agente: _this.pId_Agente,
                pId_Agp_Tarifa: _this.agrupadores.idTarifa,
                pId_VersTr_AgpT: 0,
                pId_UsuarioLogueado: _this.pId_Agente,
            },
        };

        const pdfStatus = await store.dispatch("metodoPost", payload);

        if (pdfStatus) {
            const pdfResponse = store.getters.getRespuestaREST;
            const pdfWindow = window.open("");
            if (!pdfWindow) {
                alert("Se ha bloqueado la nueva ventana");
            }
            pdfWindow.document.write(`<iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(pdfResponse.data)}'></iframe>`)
        }
    }

    static async getAgente() {
        const payload = {
            metodo: "GET_AGENTE",
            data: {
                ClaveAgente: localStorage.getItem("userId"),
            },
        };

        await store.dispatch("metodoPost", payload);
        return store.getters.getRespuestaREST.psNombre_Agente;
    }
}